// extracted by mini-css-extract-plugin
export default {"wrapper":"medical_wrapper__X652K","questionContainer":"medical_questionContainer__CuYqL"};